import React from 'react';
import map from '../../assets/images/map.png';

const globalSpread = () => {
  return (  
    <div className="global-spread">
      <div className="text-center mt-5 mb-5">
        <p className="text-primary fs-36">Global Spread</p>
        <p className="fs-15 text-gray">Building a safer tomorrow.</p>
      </div>
      <div className="row">
        <div className="col-md-8 text-center">
          <img src={map} alt="Map" className="global-spread-img" />
        </div>
        <div className="col-md-3 text">
          <span className="fs-72 font-weight-thin">1400+</span><br></br>
          <span className="fs-24 text-secondary">Employees</span>
          <div className="row mt-5 text-2">
            <div className="col-md-5">
              <span className="fs-72 font-weight-thin">4</span><br></br>
              <span className="fs-24 text-secondary">Countries</span>
            </div>
            <div className="col-md-6 languages">
              <span className="fs-72 font-weight-thin">44</span><br></br>
              <span className="fs-24 text-secondary">Languages</span>
            </div>
          </div>          
        </div>
      </div>
    </div>
  );
}
 
export default globalSpread;